import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { API_VPP, URL_SUPPORT, ROW_COUNT } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import AdminLista from "../AdminLista";
interface IVppProps {
  items?: Array<any>;
}
const VicePresidencia = ({ items }: IVppProps) => {
  const userInfo = cognitoUserToken();
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let params = { PAGINA: 1, PAGINADO: pageSize, ORDENADOPOR: "ID", ORIENTACION: "DESC" };
    let vpps =
      items !== undefined
        ? { data: items, pages: 10 }
        : (await getAPI(`${URL_SUPPORT}${API_VPP}/getall`, { Authorization: `Bearer ${token}` }, params)).result;

    let list = vpps.data;
    let pages = vpps.pages;
    setPages(pages);

    setListItems(list);
    setIsLoading(false);
  }, [token]);

  const paging = (page: any) => {
    setPage(page);
    let params = { PAGINA: page };
    filter(params, true);
  };

  const filter = (filter: any, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    filter.PAGINADO = size;
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_VPP}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        setListItems(result.result.data);
        setPages(result.result.pages);
      })
      .catch((error) => {});
  };

  const edit = (value: any, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;

    postAPI(`${URL_SUPPORT}${API_VPP}`, value, { Authorization: `Bearer ${token}` })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        filter(filters, value?.ID > 0);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            {
              ACTIVO: true,
              ORDENADOPOR: "",
              ORIENTACION: "",
              PAGINA: 1,
              PAGINADO: 10,
              TITULO: "",
              CONTRATISTA: "",
              GERENCIA: "",
              ID_CONTRATISTA_SUBCONTRATISTA: 1,
              ID_GERENCIA_SUBGERENCIA: 1,
              PREVENCIONISTA: "",
              PREVENCIONISTA_DISPLAY: "",
              RESPONSABLE: "",
              RESPONSABLE_DISPLAY: "",
            },
            {}
          );
          paging(1);
        }}></button>
      <AdminLista
        reload={filter}
        callback={edit}
        data={listItems}
        tipo={"Vicepresidencia"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Vicepresidencia"
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default VicePresidencia;
